import styled from '@emotion/styled';
import { css } from '@styled-system/css';
import React from 'react';

import { Flex, Icon, Text } from '~/components/blocks';
import { theme } from '~/styles/theme';
import { PasswordPolicy, passwordRules } from '~/utils/password';

type Props = {
  password: string;
  policy: PasswordPolicy;
};

const Wrap = styled(Flex)(() =>
  css({
    flexDirection: 'column',
    gap: theme.space.xs,
  }),
);

/**
 * パスワードのルールをチェックリストで表示する。
 * 条件は独立して満たせるため、1行のエラー文ではどれが足りないか伝わらない。
 */
export const PasswordRuleChecklist = ({ password, policy }: Props) => (
  <Wrap>
    {passwordRules(password, policy).map((rule) => (
      <Flex key={rule.label} alignItems="center">
        <Icon
          icon={rule.satisfied ? 'check' : 'close'}
          size="s"
          color={rule.satisfied ? 'green' : 'grey'}
        />
        <Text size="s" color={rule.satisfied ? 'black' : 'grey'} ml={theme.space.xs}>
          {rule.label}
        </Text>
      </Flex>
    ))}
  </Wrap>
);
